import { ParamsList } from '../../validator/shared';
import vipCompactCarmoneyParamsList from '../vip-compact-carmoney/params-list';

const paramsList: ParamsList = vipCompactCarmoneyParamsList;

export default paramsList;
